__turbopack_context__.v({
  "controls": "XKZgCW_controls",
  "controls__navigation": "XKZgCW_controls__navigation",
  "controls__navigation-button": "XKZgCW_controls__navigation-button",
  "controls__navigation-button--next": "XKZgCW_controls__navigation-button--next",
  "controls__navigation-button--prev": "XKZgCW_controls__navigation-button--prev",
  "controls__pagination": "XKZgCW_controls__pagination",
  "hero-carousel": "XKZgCW_hero-carousel",
  "hero-carousel--address-lookup": "XKZgCW_hero-carousel--address-lookup",
  "hero-carousel--homepage": "XKZgCW_hero-carousel--homepage",
  "hero-carousel--single": "XKZgCW_hero-carousel--single",
  "hero-carousel__inner": "XKZgCW_hero-carousel__inner",
  "hero-carousel__product-lookup": "XKZgCW_hero-carousel__product-lookup",
  "hero-carousel__squiggle": "XKZgCW_hero-carousel__squiggle",
  "hero-carousel__swiper": "XKZgCW_hero-carousel__swiper",
  "slide": "XKZgCW_slide",
  "slide__content": "XKZgCW_slide__content",
  "slide__description": "XKZgCW_slide__description",
  "slide__heading": "XKZgCW_slide__heading",
  "slide__image": "XKZgCW_slide__image",
  "slide__squiggle": "XKZgCW_slide__squiggle",
});
